import Image from 'next/image';
import { useEffect, useState } from 'react';
import SearchModal from './SearchModal';
import router from 'next/router';
import { isVideo } from '../utils/isVideo';
import { useMediaQuery } from '../hooks/mediaQuery';
import Trustbar from '../shared-components/Trustbar';

interface MediaItem {
  url: string;
}

interface IProps {
  title: string;
  snippet: string;
  media: MediaItem[];
}

const PageHero = ({ title, snippet, media }: IProps): JSX.Element => {
  const isDesktop = !useMediaQuery(767);

  return (
    <>
      <section
        id="landingPageHero"
        className="w-[80%] relative flex flex-col  mt-4 lg:mt-6 md:w-[90%] lg:w-[85%] 3xl:w-[80%] max-w-[1750px]  mx-auto"
      >
        <div className="relative  mt-8 xl:mt-12   md:h-[54vw]  mmd:h-[45vw] xl:h-[40vw] 2xl:h-[38vw] 4xl:h-[36vw] shrink-0 ">
          <div className="w-full md:w-[50%] xl:w-[70%] relative z-50 md:mt-12 ">
            <h1 className="text-[57px] msm:w-[60%] mmd:w-full xl:w-full 3xl:w-[75%] md:leading-[110%] md:text-[75px] xl:text-[106px] font-[900] leading-[100%] text-black [text-shadow:_-2px_-2px_0_white,_2px_-2px_0_white,_-2px_2px_0_white,_2px_2px_0_white]">
              {title?.toUpperCase()}
            </h1>
            <h2 className="hidden  md:flex w-full mmd:w-full  mlg:w-full  mt-4 xl:w-[52%] 2xl:w-[50%] font-[500] text-[20px] xl:text-[22px] xl:mt-4 leading-[100%] text-left text-[#101010]">
              {snippet}
            </h2>
            <div className="hidden xl:block w-[85%] xl:w-[80%] 2xl:w-[70%] mt-8">
              <SearchModal />
            </div>
          </div>

          <div className="hidden md:flex absolute right-10 xl:right-[5%] top-0 w-[57%] xl:w-[56.5%] z-10">
            <div className="w-full flex flex-col mr-3">
              <div
                className="rounded-[24px] md:rounded-lg w-full overflow-hidden"
                style={{ aspectRatio: '16/11' }}
              >
                {media?.[0]?.url && isVideo(media[0]?.url) ? (
                  <div className="w-full h-full">
                    <video
                      src={media[0].url}
                      className="w-full h-full object-cover"
                      autoPlay
                      muted
                      loop
                      playsInline
                      preload="auto"
                      poster="/placeholder.webp"
                    />
                  </div>
                ) : (
                  <Image
                    src={media?.[0]?.url || '/placeholder.webp'}
                    alt="Hero Image"
                    width={1920}
                    height={1080}
                    priority
                    className="w-full h-full object-cover"
                  />
                )}
              </div>

              <div className="w-[47%] md:w-[52%] self-end -mr-5 -mt-8 md:-mr-12  xl:-mt-[20%] xl:-mr-16 relative">
                <Image
                  src="/red-triangle.svg"
                  alt="red triangle"
                  width={62}
                  height={62}
                  className="w-[17%] md:w-[16%] absolute right-[9%] md:right-[19%] lg:right-[12%] xl:right-[12%] 2xl:right-[10%] 3xl:right-[9%]  -top-[14%] xl:-top-[16%] rotate-90"
                />
                <Image
                  src={media?.[1]?.url || '/placeholder.webp'}
                  width={813}
                  height={542}
                  priority
                  alt="small image"
                  className="rounded-[24px] w-full h-full"
                />
              </div>
            </div>
          </div>

          <div className="flex md:hidden w-full justify-end -mt-12 ">
            <div className="w-[81%] flex flex-col mr-3">
              <div className="aspect-[16/11]  rounded-[24px] md:rounded-lg w-full overflow-hidden">
                {media?.[0]?.url && isVideo(media[0]?.url) ? (
                  <video
                    src={media[0].url}
                    className="w-full h-full object-cover"
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    poster="/placeholder.webp"
                  >
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <Image
                    src={media?.[0]?.url || '/placeholder.webp'}
                    alt="Hero Image"
                    width={1920}
                    height={1080}
                    priority
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
              <div className="w-[47%] md:w-[51%] self-end -mr-5 -mt-8 relative">
                <Image
                  src="/red-triangle.svg"
                  alt="red triangle"
                  width={62}
                  height={62}
                  className="w-[17%] absolute right-[9%] -top-[14%] rotate-90"
                />
                <Image
                  src={media?.[1]?.url || '/placeholder.webp'}
                  width={813}
                  height={542}
                  alt="small image"
                  className="rounded-[24px] w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full my-6 md:hidden">
          <h2 className="font-[500]  mmsm:w-[80%] mx-auto text-[16px] leading-[100%] text-center text-[#101010]">
            {snippet}
          </h2>
          <div
            onClick={() => {
              router.push('/cities');
            }}
            className="md:hidden flex mt-6 rounded-[40px] justify-center items-center text-[18px] text-white font-[400] w-[205px] mx-auto bg-primary py-2"
          >
            Browse Our Cities
          </div>
        </div>
      </section>
      <div className="w-[80%] mx-auto  mt-4 xl:mt-6 ">
        <Trustbar />
      </div>
    </>
  );
};

export default PageHero;
